import axios from 'axios';

const runApiProtocol = location.protocol;
var runApiHostname = location.hostname;
const runApiPort = 40682;

var runApiUrl = null;
if (runApiHostname=="localhost") {
    runApiUrl = runApiProtocol + "//" + runApiHostname + ":" + runApiPort + "/v1/";
} else {
    const idx = runApiHostname.indexOf('.');
    runApiHostname = runApiHostname.substring(0,idx) + "-api" + runApiHostname.substring(idx);
    runApiUrl = runApiProtocol + "//" + runApiHostname + ":" + runApiPort + "/v1/";
}

const envApiUrl = process.env.VUE_APP_API;

var apiUrl = null;

if(envApiUrl){
    apiUrl = envApiUrl;
}else{
    apiUrl = runApiUrl;
}

console.log("API_URL: "+apiUrl);

const api = axios.create({baseURL: apiUrl});

export default api;